export default "__VITE_ASSET__a96ac9e9__"